var _metadata, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLRocketMoneyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 727.12 91.146667",
    height: 91.146667,
    width: 727.12,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,91.146667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1909,425.578 213,-274 h -153 l -195,256 v -256 h -129 v 522 h 129 v -233 l 188,233 h 152 l -205,-248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2308,259.578 h 248 v -108 h -377 v 522 h 365 v -107 h -236 v -96 h 213 v -104 h -213 v -107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2608,673.578 v -107 h 159 v -415 h 128 v 415 h 158 v 107 h -445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2608,673.578 v -107 h 159 v -415 h 128 v 415 h 158 v 107 h -445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 298,502.578 c 0,39 -31,66 -75,66 h -94 v -132 h 94 c 45,0 75,27 75,66 z m 8,-150 157,-201 H 315 l -187,252 v -252 H 0 v 522 h 235 c 112,0 190,-69 190,-169 0,-71 -45,-135 -119,-152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#dd1731",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 772,570.578 c 94,0 168,-72 168,-171 0,-78 -39,-125 -91,-160 l 72,-96 c 89,61 145,145 145,256 0,164 -130,283 -294,283 -163,0 -294,-119 -294,-283 0,-111 56,-195 145,-256 l 72,96 c -52,35 -91,82 -91,160 1,99 74,171 168,171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1517,296.578 67,-91 c -49,-43 -109,-62 -184,-62 -147,0 -274,107 -274,271 0,160 126,269 274,269 71,0 135,-18 183,-57 l -70,-95 c -28,22 -62,39 -113,39 -81,0 -146,-64 -146,-159 0,-93 65,-156 148,-156 50,0 85,18 115,41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3255.69,678.578 h 82.9 l 167.72,-242.902 167.71,242.902 h 84.82 v -520.5 h -73.25 V 570.621 L 3519.8,329.648 h -23.13 L 3330.88,570.621 V 158.078 h -73.26 v 520.5 h -1.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4154.04,343.145 c 0,75.183 -50.12,127.234 -123.38,127.234 -71.33,0 -121.45,-52.051 -121.45,-127.234 0,-77.114 52.05,-127.235 121.45,-127.235 73.26,0 123.38,52.051 123.38,127.235 z m -318.08,0 c 0,111.808 80.96,192.777 194.7,192.777 115.67,0 194.71,-80.969 194.71,-192.777 0,-111.813 -79.04,-192.778 -194.71,-192.778 -113.74,1.926 -194.7,80.965 -194.7,192.778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4637.91,381.699 V 160.004 h -69.4 v 206.273 c 0,65.543 -32.77,106.028 -92.53,106.028 -59.76,0 -102.18,-44.34 -102.18,-107.957 v -206.27 h -69.4 v 370.133 h 69.4 V 476.16 c 25.07,38.555 69.4,59.762 123.38,59.762 88.68,0 140.73,-53.977 140.73,-154.223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4990.69,373.988 c -7.71,65.543 -46.26,104.102 -106.02,104.102 -57.84,0 -106.03,-38.559 -113.74,-104.102 z m 73.26,-50.121 h -293.02 c 5.78,-69.402 52.05,-111.812 117.59,-111.812 52.05,0 84.82,23.133 107.96,46.265 l 48.19,-36.625 c -28.91,-34.703 -77.11,-69.402 -156.15,-69.402 -113.74,0 -186.99,82.895 -186.99,190.852 0,109.882 79.04,192.777 185.06,192.777 106.03,0 179.29,-79.039 179.29,-202.418 v -9.637 h -1.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 5453.36,528.211 5302.99,146.512 C 5264.44,44.3398 5218.17,0 5141.06,0 h -5.78 l -15.43,63.6172 h 9.64 c 44.34,0 77.11,23.1328 109.89,102.1718 l 3.85,7.711 -154.22,352.781 h 77.11 l 113.74,-271.816 102.17,271.816 h 71.33 v 1.93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLRocketMoneyLogo);
export default __webpack_public_path__ + "static/media/L-RocketMoneyLogo.f6c862050d52db6079c41164852da813.svg";
export { ForwardRef as ReactComponent };